<template>
  <cookie-law
    theme="blood-orange"
    storageType="localStorage"
    :button-text="$t('Accept')"
    :button-decline="true"
    :button-decline-text="$t('Decline')"
    button-decline-class="Cookie__button"
    :button-link="{ name: 'Privacy' }"
    :button-link-text="$t('More information')"
    :message="$t('This site uses cookies to offer you a better user experience.')"
    @accept="insertScript"
  />
</template>

<script>
const GOOGLE_SCRIPT = `
 (function() {

    var u="https://www.googletagmanager.com/gtag/js?id=G-RFKM997WSC";

   
    var d=document, g=d.createElement('script'), s=d.getElementsByTagName('script')[0];

    g.type='text/javascript'; g.async=true; g.src=u; s.parentNode.insertBefore(g,s);

  })();
  window.dataLayer = window.dataLayer || [];
  function gtag(){dataLayer.push(arguments);}
  gtag('js', new Date());
  gtag('config', 'G-RFKM997WSC');
 `
 import CookieLaw from 'vue-cookie-law'

 export default {
   components: { CookieLaw },
    mounted() {
    this.$nextTick(() => {
     console.log('cookie consent' , typeof localStorage.getItem('cookie:accepted'))
     if(localStorage.getItem('cookie:accepted') === 'true'){
      this.insertScript()
     }
    })
  },
   methods: {
    insertScript() {
      let g_script = document.querySelector('.js-analytics')
      if (g_script !== null) return
      g_script = document.createElement('script')
      g_script.classList.add('js-analytics')
      g_script.textContent = GOOGLE_SCRIPT
      document.head.appendChild(g_script)
     
     
    },
     enableTracking() {
      //  this.$gtag.enable()
       this.insertScript()
     this.$gtag.config({
        enabled: true
      });
      
     }
   }
 }
</script>

